module.exports = __webpack_public_path__ + "media/home3-left.bb88cc04.mp4";